import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";
import SystemsDetailsLanding from "./components/details/landing";
import AddSystemLanding from "./components/create/create";

export interface systemsRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: systemsRoute[];
}

export const systemsRoutes: systemsRoute[] = [
  {
    path: "/ax/asset-registry/systems",
    element: <Landing />,
  },
  {
    path: "/ax/asset-registry/systems/:action",
    element: <AddSystemLanding editMode={false} />,
  },
  {
    path: "/ax/asset-registry/systems/:action/:systemsId",
    element: <AddSystemLanding editMode={true} />,
  },
  {
    path: "/ax/asset-registry/systems/view/:systemId/:systemNo",
    element: <SystemsDetailsLanding />,
  },
    {
    path: "/ax/asset-registry/systems/view/:systemId",
    element: <SystemsDetailsLanding />,
  },
];
